import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_ALERT, PROMETHEAN_TEXT, PROMETHEAN_ERROR_OR_DESTRUCT, PROMETHEAN_BLUE, PROMETHEAN_SUCCESS_GREEN } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT, PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_SUBTITLE_01 } from '../styles/typography/typography';
export var ROOT_PREFIX = 'EmbersStatusIcon';
var ICONS = {
  small: {
    fontSize: '16px',
    lineHeight: '20px'
  },
  medium: {
    fontSize: '24px'
  },
  large: {
    fontSize: '42px'
  }
};
var ICON_STYLE = function ICON_STYLE() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefix, ".").concat(ROOT_PREFIX, "-alert"), {
    '&-icon': {
      color: PROMETHEAN_ALERT
    },
    '&-text': {
      color: PROMETHEAN_TEXT
    }
  }), "".concat(prefix, ".").concat(ROOT_PREFIX, "-error"), {
    '&-icon': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT
    },
    '&-text': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT
    }
  }), "".concat(prefix, ".").concat(ROOT_PREFIX, "-success"), {
    '&-icon': {
      color: PROMETHEAN_SUCCESS_GREEN
    },
    '&-text': {
      color: PROMETHEAN_SUCCESS_GREEN
    }
  }), "".concat(prefix, ".").concat(ROOT_PREFIX, "-destructiveSuccess"), {
    '&-icon': {
      color: PROMETHEAN_TEXT
    },
    '&-text': {
      color: PROMETHEAN_TEXT
    }
  }), "".concat(prefix, ".").concat(ROOT_PREFIX, "-important"), {
    '&-icon': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT
    },
    '&-text': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT
    }
  }), "".concat(prefix, ".").concat(ROOT_PREFIX, "-notification"), {
    '&-icon': {
      color: PROMETHEAN_TEXT
    },
    '&-text': {
      color: PROMETHEAN_TEXT
    }
  }), "".concat(prefix, ".").concat(ROOT_PREFIX, "-info"), {
    '&-icon': {
      color: PROMETHEAN_BLUE
    },
    '&-text': {
      color: PROMETHEAN_TEXT
    }
  });
};
export var StyledStatusIconItem = styled('div')(function (props) {
  return _defineProperty({}, "&.".concat(ROOT_PREFIX), _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    cursor: props['data-textclickable'] ? 'pointer' : 'default',
    display: 'flex'
  }, ".".concat(ROOT_PREFIX, "-text"), {
    textAlign: 'left'
  }), ".".concat(ROOT_PREFIX, "-icon-clickable"), {
    cursor: 'pointer'
  }), '&-small', _defineProperty(_defineProperty({}, ".".concat(ROOT_PREFIX, "-icon"), ICONS.small), ".".concat(ROOT_PREFIX, "-text"), _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
    color: 'inherit',
    marginLeft: 4
  }))), '&-medium', _defineProperty(_defineProperty({}, ".".concat(ROOT_PREFIX, "-icon"), ICONS.medium), ".".concat(ROOT_PREFIX, "-text"), _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
    color: 'inherit',
    marginLeft: 8
  }))), '&-large', _defineProperty(_defineProperty({}, ".".concat(ROOT_PREFIX, "-icon"), ICONS.large), ".".concat(ROOT_PREFIX, "-text"), _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_01), {}, {
    color: 'inherit',
    marginLeft: 8,
    paddingTop: 11
  }))), ICON_STYLE()));
});
export var StyledStatusIcon = styled('i')(_objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&.".concat(ROOT_PREFIX, "-icon-clickable"), {
  cursor: 'pointer'
}), "&.".concat(ROOT_PREFIX, "-small"), _defineProperty({}, "&.".concat(ROOT_PREFIX, "-icon"), ICONS.small)), "&.".concat(ROOT_PREFIX, "-medium"), _defineProperty({}, "&.".concat(ROOT_PREFIX, "-icon"), ICONS.medium)), "&.".concat(ROOT_PREFIX, "-large"), _defineProperty({}, "&.".concat(ROOT_PREFIX, "-icon"), ICONS.large)), ICON_STYLE('&')));